import logo from './logo.svg';
import './App.css';
import AiHelper from './AiHelper.js';

function App() {
  return <AiHelper />;
}

export default App;
